<template>
  <footer class="footer">
    <p class="disclaimers">
      <span>&copy; 2018 Jeep NZ</span>
      <router-link to="/page/terms">Terms &amp; Conditions</router-link>
      <router-link to="/page/privacy">Privacy Policy</router-link>
      <router-link to="/instructions">Instructions</router-link>
      <a @click="logout">Logout</a>
    </p>
    <div class="social">
      <a href="https://www.facebook.com/JeepNewZealand/" target="_blank" class="facebook">
        <img src="../assets/social-facebook.svg" alt="facebook">
      </a>
      <!-- <a href="https://www.facebook.com/JeepNewZealand/" target="_blank" class="twitter">
        <img src="../assets/social-twitter.svg" alt="twitter">
      </a> -->
      <a href="https://www.instagram.com/jeepnz/" target="_blank" class="instagram">
        <img src="../assets/social-instagram.svg" alt="instagram">
      </a>
      <!-- <a href="" class="google-plus">
        <img src="../assets/social-google-plus.svg" alt="google-plus">
      </a> -->
      <a href="https://www.youtube.com/channel/UC4nhqGmCwP3EvpN2JyaIZXw" target="_blank" class="youtube">
        <img src="../assets/social-youtube.svg" alt="youtube">
      </a>
    </div>
    <div class="bpb">
      <a href="https://brownpaperbag.co.nz/">Handcrafted by Brownpaperbag</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
    logout () {
      this.$store.state.isLoading = true
      this.$store.commit('logout')
      setTimeout(() => {
        this.$store.state.isLoading = false
        this.$router.push('/')
      }, 500)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../scss/variables.scss";
.footer {
  position: relative;
  z-index: 1;

  width: 100%;
  padding: 54px 3% 14px;
  margin: 0 auto;

  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.55);
  background-image: linear-gradient(180deg, #282828 0%, #000000 100%);

  .disclaimers {
    margin: 0 0 14px;

    font-size: 13px;
    line-height: 24px;
    text-align: center;

    color: $grey-5;

    @media (min-width: $medium) {
      float: left;
      margin: 0 0 44px;
      text-align: left;
    }

    a, span {
      display: block;
      font-weight: 400;
      color: $grey-5;
      cursor: pointer;

      @media (min-width: $medium) {
        display: inline-block;
        margin-right: 26px;
      }
    }
  }

  .social {
    text-align: center;
    margin-bottom: 20px;

    @media (min-width: $medium) {
      float: right;
      margin-bottom: 0;

      text-align: right;
    }

    a {
      display: inline-block;
      margin: 0 7px;
    }
  }

  .bpb {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100px;
    margin: auto 0 0;

    border-top: 1px solid $grey-5;

    @media (min-width: $medium) {
      justify-content: flex-end;
    }

    a {
      padding: 11px 18px;

      font-size: 11px;
      font-weight: 300;
      line-height: 18px;

      color: white;
      border: 1px solid white;
    }
  }
}
</style>
